import React from 'react';
import { motion } from 'framer-motion';
import './ServicesSection.css';

const ServicesSection = () => {
  const services = [
    {
      icon: '🏗️',
      title: 'CONSTRUCTION SERVICES',
      items: [
        'Residential Construction: Luxury villas, apartments, and custom homes',
        'Commercial Construction: Office complexes, retail spaces, and mixed-use developments',
        'Industrial Construction: Warehouses, manufacturing facilities, and logistics centers',
        'Renovation & Retrofitting: Modernization of existing structures'
      ]
    },
    {
      icon: '🏢',
      title: 'PROPERTY DEVELOPMENT',
      items: [
        'Land Acquisition & Development: Strategic site selection and development planning',
        'Project Conceptualization: From feasibility studies to detailed project planning',
        'Regulatory Compliance: Government approvals and clearances management',
        'Financial Structuring: Investment planning and funding arrangements'
      ]
    },
    {
      icon: '📋',
      title: 'CONSULTANCY & ADVISORY',
      items: [
        'Real Estate Advisory: Market analysis, investment guidance, and portfolio management',
        'Project Management: End-to-end project coordination and execution oversight',
        'Regulatory Consulting: RERA, environmental, and municipal approvals',
        'Due Diligence: Property evaluation and risk assessment'
      ]
    },
    {
      icon: '🛒',
      title: 'CONSTRUCTION MATERIALS & TRADING',
      items: [
        'Quality Materials Sourcing: Partnerships with leading suppliers across India',
        'Supply Chain Management: Efficient procurement and logistics solutions',
        'Quality Assurance: Rigorous testing and certification processes',
        'Cost Optimization: Value engineering and competitive pricing'
      ]
    },
    {
      icon: '🤝',
      title: 'REAL ESTATE SERVICES',
      items: [
        'Buying & Selling: Comprehensive transaction management',
        'Leasing Services: Commercial and residential lease facilitation',
        'Property Management: Maintenance and operational support',
        'Investment Services: Portfolio development and management'
      ]
    }
  ];

  return (
    <section className="services-detailed-section">
      <div className="services-detailed-container">
        {/* Hero Section */}
        <motion.div
          className="services-hero"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <motion.h2
            className="services-title"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Our <span className="highlight">Services</span>
          </motion.h2>

          <motion.p
            className="services-subtitle"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            Comprehensive construction, development, and real estate solutions tailored to your needs. From initial planning to final delivery, we provide end-to-end services that ensure excellence at every stage.
          </motion.p>
        </motion.div>

        {/* Services Grid */}
        <motion.div
          className="services-grid-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="services-grid">
            {services.map((service, index) => (
              <motion.div
                key={service.title}
                className="service-detailed-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -5 }}
              >
                <div className="service-detailed-header">
                  <div className="service-detailed-icon">{service.icon}</div>
                  <h3 className="service-detailed-title">{service.title}</h3>
                </div>
                <div className="service-detailed-content">
                  <ul className="service-detailed-list">
                    {service.items.map((item, itemIndex) => (
                      <li key={itemIndex}>{item}</li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;











